import { render, staticRenderFns } from "./PDF.vue?vue&type=template&id=640b8483&scoped=true&"
import script from "./PDF.vue?vue&type=script&lang=ts&"
export * from "./PDF.vue?vue&type=script&lang=ts&"
import style0 from "./PDF.vue?vue&type=style&index=0&id=640b8483&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b8483",
  null
  
)

export default component.exports